function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import _ from 'lodash';
import { useMemo } from 'react';
import IconLock from '~icons/bx/lock';
import IconChevronDown from '~icons/ci/chevron-down';
import { contrastingTextColor, theme } from '@arc/frontend/ui-theme';
import { HubTooltip } from './HubTooltip';
import { Menu, MenuButton, MenuItem, MenuList } from './MenuButton';
import { StatusDisplay } from './StatusDisplay';
import { Tag } from './Tag';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ff36h2",
  styles: "flex-grow:1"
} : {
  name: "18oibnl-listItemPill",
  styles: "flex-grow:1;label:listItemPill;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = {
  icon: process.env.NODE_ENV === "production" ? {
    name: "fa1sd1",
    styles: "display:flex;flex-direction:row;align-items:center;align-self:center;justify-content:center;margin-right:-0.25rem;margin-top:1px;justify-self:center"
  } : {
    name: "17v82y1-icon",
    styles: "display:flex;flex-direction:row;align-items:center;align-self:center;justify-content:center;margin-right:-0.25rem;margin-top:1px;justify-self:center;label:icon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  // make pill take full width
  listItem: process.env.NODE_ENV === "production" ? {
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
  } : {
    name: "kwgqkp-listItem",
    styles: "display:flex;flex-direction:row;label:listItem;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  listItemPill: border => [_ref, border && /*#__PURE__*/css({
    borderColor: theme.colors.text.secondary,
    borderWidth: '1px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItemPill;")]
};
const defaultBackground = theme.colors.background.tag.green;
export function StatusMenu({
  status,
  statusOptions,
  onStatusChange,
  outerStyle,
  disabled,
  statusColor,
  manuallyConverted
}) {
  const backgroundColor = useMemo(() => statusOptions.find(option => option.value === status)?.color ?? statusColor ?? defaultBackground, [status, statusOptions, statusColor]);
  const handleOnClick = newStatus => {
    onStatusChange(newStatus);
  };
  const textColor = statusOptions.find(so => !!so.textColor)?.textColor ?? contrastingTextColor(backgroundColor);
  const statusDisabled = disabled || status === 'converted' && !manuallyConverted;
  return <div css={outerStyle}>
			<Menu trigger={<MenuButton data-testid="status-menu" data-disabled={statusDisabled} css={["height:100%;", statusDisabled && {
      opacity: '0.5',
      cursor: 'default'
    }, process.env.NODE_ENV === "production" ? "" : ";label:StatusMenu;"]}>
						<StatusDisplay status={status} backgroundColor={backgroundColor} textColor={textColor} leftIcon={status === 'converted' && !manuallyConverted ? <HubTooltip title={'This quote was converted on the website and cannot be reversed.'}>
										<IconLock width={20} height={20} css={[styles.icon, {
          color: textColor,
          marginRight: '0.2rem'
        }, process.env.NODE_ENV === "production" ? "" : ";label:StatusMenu;"]} />
									</HubTooltip> : null} rightIcon={<IconChevronDown width={20} height={20} css={[styles.icon, {
        color: textColor
      }, disabled && {
        display: 'none'
      }, process.env.NODE_ENV === "production" ? "" : ";label:StatusMenu;"]} />} />
					</MenuButton>}>
				<MenuList css={statusDisabled ? {
        display: 'none'
      } : null} data-testid="status-menu-popover">
					{statusOptions.map(option => <MenuItem key={option.value} onSelect={() => handleOnClick(option.value)} data-testid={`status-menu-${option.value}`} css={styles.listItem}>
							<Tag text={_.upperFirst(option.value)} textStyles={option.textColor ? {
            color: option.textColor
          } : null} color={option.color ?? backgroundColor} size="clickable" css={styles.listItemPill(option.color === '#FFFFFF')} />
						</MenuItem>)}
				</MenuList>
			</Menu>
		</div>;
}